import React from "react";
import "./Our_Presence.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faMapLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

const Our_Presence = () => {
  return (
    <section className="Our_Presence">
      <div className="map_img_holder">
        <div className="mapouter">
          <div className="gmap_canvas">
            <iframe
              className="gmap_iframe"
              width="100%"
              height="432"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src="https://maps.google.com/maps?width=1532&height=432&hl=en&q=&t=&z=20&ie=UTF8&iwloc=B&output=embed"
              title="map"
            ></iframe>
          </div>
        </div>
      </div>
      <div className="custom_container">
        <div className="contact_info_holder">
          <div className="row me-0 ms-0">
            <div className="col-md-4">
              <div className="content_holder">
                <div>
                  <h4>
                    {" "}
                    <FontAwesomeIcon
                      className="info_icon"
                      icon={faMapLocationDot}
                    />{" "}
                    ADDRESS
                  </h4>
                  <p>
                    Ellora Shopee , A-Wing , Sector- 01 , 03 First Floor,
                    Indrayani Nagar, Bhosari Pune, Maharashtra- 411026
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="content_holder center_info_card">
                <div>
                  <h4>
                    {" "}
                    <FontAwesomeIcon
                      className="info_icon"
                      icon={faPhone}
                    />{" "}
                    CONTACT
                  </h4>
                  <p>+91 8087110156</p>
                   <p>+91 9422005802</p>
                    <p>+91 9370572938</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="content_holder">
                <div>
                  <h4>
                    {" "}
                    <FontAwesomeIcon
                      className="info_icon"
                      icon={faEnvelope}
                    />{" "}
                    EMAIL
                  </h4>
                  <p>sales@ayzair.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Our_Presence;
